module.exports = __webpack_public_path__ + "img/25.70f79f9a.jpg";